import { jsPDF } from "jspdf";

const GREEN = [255, 26, 130];
const PINK = [16, 185, 129];
const INK = [26, 26, 26];
const GRAY = [102, 102, 102];
const CREAM = [255, 251, 245];

const M = 48; // page margin
const BODY_SIZE = 18;

export function welpPdf(docTitle, sections, filename) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const maxW = W - M * 2;
  let y = 0;

  const drawHeart = (cx, cy, s) => {
    doc.setFillColor(...PINK);
    doc.circle(cx - s * 0.5, cy - s * 0.3, s * 0.55, "F");
    doc.circle(cx + s * 0.5, cy - s * 0.3, s * 0.55, "F");
    doc.triangle(cx - s * 1.02, cy - s * 0.08, cx + s * 1.02, cy - s * 0.08, cx, cy + s, "F");
  };

  const header = () => {
    doc.setFillColor(...CREAM);
    doc.rect(0, 0, W, 96, "F");
    doc.setFillColor(...GREEN);
    doc.rect(0, 96, W, 4, "F");
    doc.setFillColor(...PINK);
    doc.rect(0, 100, W, 2, "F");
    doc.setFont("times", "bolditalic");
    doc.setFontSize(36);
    doc.setTextColor(...GREEN);
    doc.text("Welp", M, 52);
    const ww = doc.getTextWidth("Welp");
    drawHeart(M + ww + 18, 42, 9);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(...INK);
    doc.text("DATING WITH INTEGRITY", M, 80);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(18);
    doc.setTextColor(...GRAY);
    doc.text("welp3x3.com", W - M, 52, { align: "right" });
    y = 134;
  };

  const footer = () => {
    const page = doc.getCurrentPageInfo().pageNumber;
    doc.setFillColor(...GREEN);
    doc.rect(0, H - 36, W, 36, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setTextColor(255, 255, 255);
    doc.text("No judgment. No discrimination. Just honesty.", M, H - 12);
    doc.text(`${page}`, W - M, H - 12, { align: "right" });
  };

  const ensure = (needed) => {
    if (y + needed > H - 54) {
      footer();
      doc.addPage();
      header();
    }
  };

  header();

  // Document title
  doc.setFont("times", "bold");
  doc.setFontSize(28);
  doc.setTextColor(...INK);
  doc.text(docTitle, M, y);
  y += 12;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(18);
  doc.setTextColor(...GRAY);
  doc.text(new Date().toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }), M, y + 20);
  y += 52;

  sections.forEach((s, idx) => {
    if (!s) return;
    const color = idx % 2 === 0 ? PINK : GREEN;
    // heading
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    ensure(34);
    doc.setTextColor(...color);
    doc.text(s.heading.toUpperCase(), M, y);
    doc.setDrawColor(...color);
    doc.setLineWidth(1.5);
    doc.line(M, y + 6, M + 60, y + 6);
    y += 28;
    // body
    doc.setFont("helvetica", "normal");
    doc.setFontSize(BODY_SIZE);
    doc.setTextColor(...INK);
    const lineH = BODY_SIZE * 1.35;
    const paras = s.items ? s.items.map(i => `\u2022  ${i}`) : String(s.text || "").split("\n").filter(Boolean);
    paras.forEach(p => {
      const lines = doc.splitTextToSize(p, maxW);
      lines.forEach(line => {
        ensure(lineH);
        doc.text(line, M, y);
        y += lineH;
      });
      y += 6;
    });
    y += 14;
  });

  footer();
  doc.save(filename);
}
